var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.999,
    height: 13.653,
    viewBox: "0 0 11.999 13.653",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "user",
    transform: "translate(-31)",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_23",
    "data-name": "Union 23",
    d: "M-228.239,11359.479a.4.4,0,0,1-.4-.4,5.245,5.245,0,0,1,1.522-3.7,5.126,5.126,0,0,1,3.678-1.551h1.6a5.132,5.132,0,0,1,3.68,1.551,5.242,5.242,0,0,1,1.52,3.7.4.4,0,0,1-.4.4Zm2-10.053a3.6,3.6,0,0,1,3.6-3.6,3.6,3.6,0,0,1,3.6,3.6,3.6,3.6,0,0,1-3.6,3.6A3.6,3.6,0,0,1-226.238,11349.427Z",
    transform: "translate(259.638 -11345.826)",
    fill: "#1a1818"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.0a4073ce7e9166036a3c02854b7404cc.svg";
export { ForwardRef as ReactComponent };